import Component from '../abstracts/Component';

export default class DropdownComponent extends Component {

  get SELECTORS() {
    return {
      accordion: '[data-js-accordion]',
      item: '[data-js-item="active"]',
      items: '[data-js-item="inactive"]',
      dropdownTrigger: '[data-dropdown-trigger]',
    };
  }

  constructor(compEl) {
    super(compEl);
    this.dropdownTrigger = this.$component.querySelectorAll(this.SELECTORS.dropdownTrigger);
  }

  render() {
    super.render();
    this.dom = this.readDOM();
    this.bindEvents();
  }

  readDOM() {
    return {
      accordion: this.$component.querySelector(this.SELECTORS.accordion),
      item: this.$component.querySelector(this.SELECTORS.item),
      items: this.$component.querySelectorAll(this.SELECTORS.items),
    }
  }

  bindEvents() {
    //Utilities dropdown : cart, checkout, my account mobile navigation
    this.dropdownTrigger.forEach((trigger, i) => {
      trigger.addEventListener('click', () =>
        this.handleDropdownTrigger(trigger)
      );
      trigger.setAttribute('data-dropdown-trigger', 'dropdown-service-' + i);
      this.slideToggle(trigger);
    });

    if(window.matchMedia('(max-width: 1279px)').matches) {
      this.bindAccordion();
    }
  }

  bindAccordion() {
    if(this.dom.accordion) {
      this.dom.accordion.prepend(this.dom.item);
      this.dom.item.addEventListener('click', (event) => {
        event.preventDefault();
        this.dom.item.classList.toggle('selected'),
        this.dom.items.forEach((item) => {
          item.classList.toggle('open');
        });
      });
    }
  }

  slideToggle(element) {
    let box = element.nextSibling;
    if(box != null) {
      if(box.style.display === '') {
        box.style.display = 'none';
      }
      else if(box.style.display === 'none') {
        box.style.display = 'block';
      }
      else {
        box.style.display = 'none';
      }
    }
  }

  handleDropdownTrigger(trigger) {
    trigger.classList.toggle('open');

    this.slideToggle(trigger);

    //closes other dropdown(s) when a new one is opened
    let contents = this.$component.querySelectorAll('.sizes-subsection');
    if(contents.length >= 1) {
      contents.forEach(content => {
        if(content.classList.contains('selected') && content.classList.contains('open')) {
          content.classList.toggle('open');
          content.classList.remove('selected');
          this.slideToggle(content);
          content.querySelector('span').classList.remove('icon-chevron-up');
          }
        });
      trigger.classList.toggle('selected');
    }

    if(!trigger.querySelector('span').classList.contains('icon-chevron-up')) {
      trigger.querySelector('span').classList.add('icon-chevron-up');
    } else {
      trigger.querySelector('span').classList.remove('icon-chevron-up');
    }

    if(this.$component.hasAttribute('data-dropdown-others')) {
      this.dropdownOthers(trigger.getAttribute('data-dropdown-trigger'));
    }
  }

  //leaves only the last selected accordion open
  dropdownOthers(id) {
    this.dropdownTrigger.forEach((trigger) => {
      if(trigger.dataset.dropdownTrigger !== id) {
        let box = trigger.nextSibling;
        if(box != null) box.style.display = 'none';
        trigger.classList.remove('open');
        trigger.querySelector('span').classList.remove('icon-chevron-up');
      }
    });
  }
}
